import { generateString } from "../../utils/zone.utils";
import { ZONE_JUST_GET_HOOK } from "../enum/ENUM";
import { SYM_SANDBOX } from "../enum/Symbol";
import { useReactiveZone } from "../useReactiveZone";
import useMap from "../utils/useMap";

/**
 * the Sanbox to execute to Component code
 * It will redfine the window and global property like setTimeout, setInterval,
 * When you want to use setTimeout, must be call injectWindow to inject it
 * Sample: const { setTimeout } = injectWindow();
 */

export const useWindowInjection = (() => {

    const defaultWindowKeys = new Set(Object.keys(window));
    defaultWindowKeys.add('useReactiveZone');

    const _window = window;

    const getPreventProps = () => {
        const props = Object.keys(window)
        // .filter(k => !defaultWindowKeys.has(k));
        return props;
    }

    const injectWindow = (function () {
        const props = arguments;
        const rs = {}
        for (let i in props) {
            const k = props[i];
            rs[k] = _window[k];
        }

        const wProxy = new Proxy({}, {
            get(target, prop) {
                if (typeof _window[prop] === "undefined") {
                    throw `${prop} does not exist`;
                }
                return _window[prop];
            }
        })
        return () => wProxy;
    })();

    const throwInjectionError = (ex) => {
        if (!ex instanceof TypeError) {
            throw new Error(ex);
        }
        ex = new TypeError(ex);
        let message = ex.message;
        const keys = new Set(getPreventProps());
        message = message.replace('TypeError:', '').trim();
        message = message.split(' ');
        while (message.length > 0) {
            const key = message.shift().replace('window.', '');
            if (keys.has(key)) {
                throw new Error(`Not allow access "${key}" direct to window global. Try const { alert } = injectWindow('${key}') instead`);
            }
        }
    }

    const extractPrevent = () => {
        const keys = getPreventProps();
        const rs = {}
        for (let i in keys) {
            let k = keys[i];
            if (typeof k !== 'number') {
                Object.defineProperty(rs, k, {
                    get: () => {
                        // throw new Error(`Not allow access "${k}" direct to window global. Try "const {alert} = injectWindow('${k}')" instead`);
                    }
                })
            }
        }
        return rs;
    };

    const preventScript = () => {
        const keys = new Set(getPreventProps());
        keys.delete('window');
        keys.delete('useReactiveZone');

        let variablesPrevented = Array.from(keys).map(item => {
            return item.includes('.') ? item.split('.')[0] : item
        });
        variablesPrevented = new Set(variablesPrevented);
        variablesPrevented = Array.from(variablesPrevented).join(',');

        const script = `const { useWindowInjection } = useReactiveZone('${ZONE_JUST_GET_HOOK}'); 
            const { ${variablesPrevented} } = useWindowInjection().extractPrevent()`
        return script;
    }

    const getWindow = () => {
        const _w = {};
        const defined = [];
        for (let i in defaultWindowKeys) {
            Object.defineProperty(_w, windowkeys[i], {
                get: () => {
                    throw new Error(`Not allow access "${windowkeys[i]}" direct to window global. Try "const {alert} = injectWindow('${windowkeys[i]}')" instead`);
                }
            })
            defined.push(windowkeys[i])

        }
        return _w;
    }


    return () => ({
        getPreventProps,
        injectWindow,
        throwInjectionError,
        extractPrevent,
        preventScript,
        getWindow
    })
})();


const useSandbox = (() => {

    const funcCaching = useMap();

    const { getWindow, preventScript, throwInjectionError } = useWindowInjection();

    const useReactiveZoneSandbox = ({ root }) => {
        const instance = useReactiveZone(SYM_SANDBOX);

        const { useTemplate } = instance;

        setTimeout(() => {
            useTemplate({
                applyRoot: root,
                template: ''
            })
        }, 0)
        instance.useTemplate = () => { }
        return () => instance
    }

    const newBox = (jsSource, { root }) => {
        const fnName = generateString(8,).trim();
        funcCaching.set(fnName, {
            root,
            fn: null
        });

        const code = `(function (window, useReactiveZone) {
            const { useSandbox } = useReactiveZone('${ZONE_JUST_GET_HOOK}');
            ${preventScript()}
               const fn = (function(){
                    const window = this;
                    return function Zone_${fnName}(window, useReactiveZone){
                        ${jsSource};
                    }
                }).call(window)
                const { injectFunction} = useSandbox();
                injectFunction('${fnName}', fn);
            }).call(window, window, useReactiveZone)`

        return {
            code,
            fnName
        };
    }

    const injectFunction = (fnName, fn) => {
        if (!funcCaching.has(fnName)) { return }
        const { root } = funcCaching.get(fnName);
        // funcCaching.set(fnName, {})
        try {
            setTimeout(() => {
                fn.call({ context: 'zoneContext' }, getWindow(), useReactiveZoneSandbox({ root }));
            });
        } catch (ex) {
            throwInjectionError(ex);
        }
    }

    return () => ({
        newBox,
        injectFunction
    })
})();

export default useSandbox;